import { ReactElement } from 'react'

import ResetPasswordImpl from '../../domain/usecases/ResetPasswordImpl'
import UserRepository from '../../infra/repositories/UserRepository'
import Forgot from '../../pages/Forgot'

export const ForgotFactory = (): ReactElement => {
  const userRepository = new UserRepository()
  const resetPasswordImpl = new ResetPasswordImpl(userRepository)

  return <Forgot resetPassword={resetPasswordImpl} />
}
